import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  USER_ROLE_ADMIN,
} from 'common/userRoles';

import {
  SCREEN_ID_ADMIN_APARTMENTS,
} from 'client/constants/screenIds';

import {
  DATA_TABLE_SOURCE_APARTMENTS,
} from 'common/dataTableConstants';

import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';
import SrText from 'client/components/SrText';
import SrPage from 'client/components/SrPage';
import SrDarkModal from 'client/components/SrDarkModal';
import SrModalContent from 'client/components/SrModalContent';
import SrApartmentForm from 'client/components/SrApartmentForm';
import SrDataTableApartments from 'client/components/SrDataTableApartments';

import allowedRoles from 'client/helpers/allowedRoles';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import { actionDataTableReset } from 'client/helpers/dataTables';

import branch from 'client/core/branch';
import PartnerActions from 'client/actions/Partner';

@withTransitionHook
@allowedRoles({
  roles: [
    USER_ROLE_ADMIN,
  ],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
@withScreenId(SCREEN_ID_ADMIN_APARTMENTS)
@withScrollToTop
@branch({
  partnersList: ['partners', 'list'],
})
class AdminApartmentsPage extends Component {
  static propTypes = {
    partnersList: PropTypes.array,
    dispatch: PropTypes.func.isRequired,
  }

  static fetchData(match, inject) {
    return PartnerActions.getPartnerList(inject);
  }

  constructor(props) {
    super(props);

    this.state = {
      isApartmentModalOpen: false,
    };
  }

  _toggleApartmentModal = () => {
    this.setState({
      isApartmentModalOpen: !this.state.isApartmentModalOpen,
    });
  }

  _onCreateApartment = () => {
    const { dispatch } = this.props;
    dispatch(actionDataTableReset, {
      dataSource: DATA_TABLE_SOURCE_APARTMENTS,
    });
    this._toggleApartmentModal();
  }

  render() {
    const { isApartmentModalOpen } = this.state;
    const { partnersList, dispatch } = this.props;

    return (
      <SrPage navbarProps={{ redirectLogoTo: '/admin' }}>
        <div className='width-90'>
          <SrFlex direction='rowReverse' margin='0 0 10px'>
            <SrText
              font='whitney-sc'
              size='xl'
              weight='medium'
              cursor='pointer'
              decoration='underline'
              onClick={this._toggleApartmentModal}
            >
              add apartment
            </SrText>
          </SrFlex>
          <SrDataTableApartments />
          {isApartmentModalOpen && (
            <SrDarkModal onClose={this._toggleApartmentModal}>
              <SrModalContent style={{ maxWidth: 440, maxHeight: 600 }}>
                <SrFlex justify='center'>
                  <SrText size='2xl' align='center'>
                    Apartment
                  </SrText>
                </SrFlex>
                <SrBox marginTop={20}>
                  <SrApartmentForm
                    apartment={{}}
                    partnersList={partnersList}
                    dispatch={dispatch}
                    onChange={this._onCreateApartment}
                  />
                </SrBox>
              </SrModalContent>
            </SrDarkModal>
          )}
        </div>
      </SrPage>
    );
  }
}

AdminApartmentsPage.displayName = 'AdminApartmentsPage';

export default AdminApartmentsPage;
